<template>
  <section class="container mx-auto">
    <h2 class="text-center" data-aos="fade-in">partners</h2>
    <div
      class="my-10 grid 24 grid-cols-5 md:grid-cols-5 mx-32 gap-x-32 gap-y-16"
    >
      <img
        v-for="(item, i) in items"
        :key="i"
        :src="item.src"
        :alt="`partner-${i},nfts,nft game,argons,Ethereum nft,opensea nft,nft coin,binance nft,nft token,nft market,buy nft,nfts meaning,most expensive nft,nft crypto art`"
        class="w-full"
      />
    </div>
  </section>
</template>

<script>
export default {
  name: "partnersComponent",
  data: () => ({
    items: [],
  }),
  created() {
    for (let i = 1; i <= 10; i++) {
      this.items.push({
        src: require(`@/assets/partner/${i}.png`),
      })
    }
  },
}
</script>
